
import React, { useState, useEffect } from "react";
import ConnectAPI from "../../services/api";
import { authenticationService } from "../../services/context/AuthService";
import Swal from "sweetalert2";
import IndigoImg from '../../assets/images/HPIndigo.png';
import englishIcon from '../../assets/images/reino-unido.png';
import spanishIcon from '../../assets/images/espana.png';
import portugueseIcon from '../../assets/images/portugal.png';
import { Row, Col, Container } from 'react-bootstrap';
import moment from "moment";
import {Modal  , Button ,IconCheckmark, Stepper, TextArea, Select,TextBox, List ,ListItem, IconX, Tabs, DatePicker} from "@veneer/core";

import { useTranslation } from "react-i18next";
import XLSX from 'xlsx';
import $, { map } from 'jquery';

const DetNotification = ({detailnotfication, onShowModal, onCloseSCDetailsModal, isnew}) => {
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [ShowModal, setShowModal] = useState(onShowModal);
    const [NewStep, setNewStep]=useState("1")
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [audience, setaudience]=useState("");
    const [optionsrole, setoptionrole]=useState([]);
    const [optionsEndUSer, setoptionsEndUSer]=useState([]);
    const [optionsChannels, setoptionsChannels]=useState([]);
    const [regionlist, setregionlist]=useState([]);
    const [roleselect, setroleselect]=useState({ value: [] } );
    const [enduserselect, setenduserselect]=useState({ value: [] } );
    const [channelselect, setchannelselect]=useState({ value: [] } );
    const [channelselect2, setchannelselect2]=useState();
    const [subregion, setsubregion]=useState({ value: [] } )
    const [ESNoti, setESNoti]=useState("");
    const [ENNoti, setENNoti]=useState("");
    const [PTNoti, setPTNoti]=useState("");
    const [emails, setemails]=useState([]);
    const [txtemails, settxtemails]=useState("");
    const [viewactivetab, setviewactivetab]=useState(0);
    const [StartDate, setStartDate]=useState("");
    const [EndDate, setEndDate]=useState("");
    

    const handleBackButtonOnChange=()=>{
        const newStepItems = [...stepItems];
        const newSelectedItem = newStepItems[currentIndex - 1];
        const oldSelectedItem = newStepItems[currentIndex];

        setNewStep(parseInt(NewStep)-1);
        newSelectedItem.status = 'current';
    
        oldSelectedItem.status = 'incomplete';
        oldSelectedItem.step = NewStep;
    
        setCurrentIndex(currentIndex - 1);
        setStepItems(newStepItems);
    }
    const handleNextButtonOnChange = () => {
        const newStepItems = [...stepItems];
        const newSelectedItem = newStepItems[currentIndex + 1];
        const oldSelectedItem = newStepItems[currentIndex];
        setNewStep(newSelectedItem.step);
        
        newSelectedItem.status = 'current';
    
        oldSelectedItem.status = 'complete';
        oldSelectedItem.step = <IconCheckmark filled />;
    
        setCurrentIndex(currentIndex + 1);
        setStepItems(newStepItems);
    };
    const handleResetButtonOnChange = () => {
        const deepcopyItems = defaultJson.map((item) => ({ ...item }));
        setNewStep("1");
        setStepItems(deepcopyItems);
        setCurrentIndex(0);


        setaudience("");
        setroleselect({ value: [] } );
        setsubregion({ value: [] } );
        setESNoti("");
        setENNoti("");
        setPTNoti("");
        setemails([]);
        settxtemails("");
        setEndDate("");
        setStartDate("");

    };
    useEffect(()=>{
        //console.log(detailnotfication);
        connectApi
        .get(
          "api/Channels/getconfignoti",
          "",
          consolidconfig
        )
    },[]);
    useEffect(()=>{

        connectApi
        .getWithParams(
          "api/Channels/getendusersnoti",
          channelselect2 ,
          consolidchannels
        )
    },[channelselect2]);
    useEffect(()=>{
        if (isnew=="NO"){
            const deepcopyItems = defaultJson.map((item) => ({ ...item }));
            setNewStep("1");
            setStepItems(deepcopyItems);
            setCurrentIndex(0);
            setESNoti(detailnotfication.messageES);
            setENNoti(detailnotfication.messageEN);
            setPTNoti(detailnotfication.messagePT);
            setEndDate(detailnotfication.endDate);
            setStartDate(detailnotfication.stardate);

            
            if (detailnotfication.audiencelevel=="role" && detailnotfication.audience.toString().includes('R')==true){
                detailnotfication.audiencelevel="role & subregion";
            }
            setaudience(detailnotfication.audiencelevel);
            switch(detailnotfication.audiencelevel){
                case "email":
                    var array=detailnotfication.audience.toString().split(",");
                    var old_emails=emails;
                    var new_emails=old_emails.concat(array)
                    setemails(new_emails);
                    break;
                case "role":
                    var array=detailnotfication.audience.toString().split(",");
                    setroleselect({ value: array });
                    break;
                case "subregion":
                    var array=detailnotfication.audience.toString().split(",");
                    const numbers = array.map((n) => {
                        return parseInt(n, 10);
                    });
                    setsubregion({ value: numbers });
                    break;
                case "role & subregion":
                    var array=detailnotfication.audience.toString().split(",");
                    var role=[];
                    var region=[];
                    var encontrado=false;
                    //console.log(array);
                    array.map((n)=>{
                        if (n=="R"){
                            encontrado=true;
                        }else{
                            if (encontrado==true){
                                region.push(parseInt(n,10));
                            }else{
                                role.push(n);
                            }
                        }
                    });
                    setroleselect({value:role});
                    setsubregion({value: region});
                    break;
                case "channel":
                    var array=detailnotfication.audience.toString().split(",");
                    setchannelselect({value: array});
                    break;
            }
        }else{
            setaudience("");
            setroleselect({ value: [] } );
            setsubregion({ value: [] } );
            setESNoti("");
            setENNoti("");
            setPTNoti("");
            setemails([]);
            settxtemails("");
            setEndDate("");
            setStartDate("");
            const deepcopyItems = defaultJson.map((item) => ({ ...item }));
            setNewStep("1");
            setStepItems(deepcopyItems);
            setCurrentIndex(0);
        }
    },[detailnotfication.idnotification]);
    const consolidchannels=(status,data)=>{
        var enduser=[];
        data.forEach(element => {
            enduser.push({
                value:element.idEndUser,
                label:element.name
            });
        });
        setoptionsEndUSer(enduser);
    }
    const consolidconfig = (status, data) => {
        setregionlist([
            { value: 2, label: 'Brazil' },
            { value: 3, label: 'Mexico' },
            { value: 31, label: 'MCA North' },
            { value: 32, label: 'MCA South' },
        ]);

        var options=[];
        var channels=[];
        var enduser=[];
        data.roles.forEach(element => {
            options.push({
                value:element.idRole,
                label:element.role
            });
        });

        data.channels.forEach(element => {
            channels.push({
                value:element.idCustomer,
                label:element.name
            });
        });

       

        //setoptionsEndUSer(enduser);
        setoptionsChannels(channels);
        setoptionrole(options);
    }
    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: "100%",
        marginTop: 20
    };
    const buttonsContainer = { display: 'flex', justifyContent: 'space-between', marginTop: 20 };
    const nextButtonStyle = { width: '45%' };
    const resetButtonStyle = { width: '45%' };

    const defaultJson = [
        {
          label: t("n_spanish"),
          status: 'incomplete',
          step: '1',
        },
        {
          label: t("n_english"),
          status: 'incomplete',
          step: '2',
        },
        {
          label: t("n_portuguese"),
          status: 'incomplete',
          step: '3',
        },
        {
          label: t("Audience"),
          status: 'incomplete',
          step: '4',
        }, 
        {
            label: t("View"),
            status: 'incomplete',
            step: '5',
        },    
    ];
    const [stepItems, setStepItems] = React.useState(defaultJson);
    const handleChange = ({ value }) => {
        const valueCopy = [...roleselect.value];
        const isOptionSelected = valueCopy.includes(value);
  
        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
  
        setroleselect({ value: valueCopy });
    }

    const handleChange2 = ({ value }) => {
        const valueCopy = [...subregion.value];
        const isOptionSelected = valueCopy.includes(value);
    

        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        setsubregion({ value: valueCopy });
        //console.log(subregion);
    }

    const enduserchange = ({ value }) => {
        const valueCopy = [...enduserselect.value];
        const isOptionSelected = valueCopy.includes(value);
    

        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        setenduserselect({ value: valueCopy });
    }
    
    const channelchange = ({ value }) => {
        const valueCopy = [...channelselect.value];
        const isOptionSelected = valueCopy.includes(value);
    

        if (isOptionSelected) {
          const index = valueCopy.indexOf(value);
          valueCopy.splice(index, 1);
        } else {
          valueCopy.push(value);
        }
        setchannelselect({ value: valueCopy });
    }
    
    function delete_email(args){
        let liItem = args.target.closest('li').getElementsByClassName("css-1wok153");
        var old_emails=emails;
        var new_emails= emails.filter((item) => item !== liItem[0].innerText)
        setemails(new_emails);
    }
    const handlechannelschange = (name) => (event) => {
        setchannelselect2(event.value);
    };
    const select_audience=()=>{
        switch(audience){
            case "role":
                return (
                    <>
                    {t("select channel")}
                    <Select
                        multiple
                        options={optionsrole}
                        id="roles"
                        label="Select Role"
                        value={roleselect.value}
                        onClear={() => setroleselect({ value: [] })}
                        onChange={handleChange}
                    />
                    </>
                );
                break;
            case "email":
                return (
                    <>
                        <Row>
                            <Col md="8">
                                {t("Enter Emails")}
                                <TextBox
                                    id="txtemails"
                                    label="Email"
                                    value={txtemails}
                                    onChange={(e) => {
                                        settxtemails(e);
                                    }
                                    }
                                />
                            </Col>
                            <Col md="4">
                                <br/>
                                <Button
                                    small
                                    name="add"
                                    onClick={()=>{
                                        if (txtemails!=""){
                                            var array=txtemails.split(",");
                                            var last=[];
                                            array.map((item, key) => {
                                                last.push(item.trim());
                                            });
                                            var old_emails=emails;
                                            var new_emails=old_emails.concat(last)
                                            setemails(new_emails);
                                            settxtemails("");
                                        }
                                        
                                    }}
                                >
                                    Add
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <List css={{padding: '20px', height: '200px', overflowY: 'auto'}}>
                                    {
                                        emails.map((item, key) => {
                                            return(
                                                <>
                                                <ListItem 
                                                    centerArea={<div>{item}</div>}
                                                    rightArea={<Button onClick={delete_email.bind(this)} id={key} aria-label="Actions" leadingIcon={<IconX />} appearance="tertiary" />}
                                                />
                                                </>
                                            )
                                        })
                                    }
                                </List>
                            </Col>
                        </Row>
                        
                    </>
                );
                break;
            case "subregion":
                return (
                    <>
                    {t("select region")}
                    <Select
                        multiple
                        options={regionlist}
                        id="subregion"
                        label="Select Subregion"
                        value={subregion.value}
                        onClear={() => setsubregion({ value: [] })}
                        onChange={handleChange2}
                    />
                    </>
                );
                break;
            case "enduser":
                return (
                    <>
                    {t("select_channel")}
                    <Select
                        
                        options={optionsChannels}
                        id="channels"
                        label="Select Channel"
                        value={[channelselect2]}
                        onClear={() => setchannelselect2()}
                        onChange={handlechannelschange()}
                    />

                    {t("select enduser")}
                    <Select
                        multiple
                        options={optionsEndUSer}
                        id="enduser"
                        label="Select End User"
                        value={enduserselect.value}
                        onClear={() => setenduserselect({ value: [] })}
                        onChange={enduserchange}
                    />
                    </>
                );
                break;
            case "channel":
                return (
                    <>
                    {t("select channel")}
                    <Select
                        multiple
                        options={optionsChannels}
                        id="channels"
                        label="Select Channel"
                        value={channelselect.value}
                        onClear={() => setchannelselect({ value: [] })}
                        onChange={channelchange}
                    />
                    </>
                );
                break;
            case "role & subregion":
                return (
                    <>
                        {t("select role")}
                        <Select
                            multiple
                            options={optionsrole}
                            id="roles"
                            label="Select Role"
                            value={roleselect.value}
                            onClear={() => setroleselect({ value: [] })}
                            onChange={handleChange}
                        />

                        {t("select region")}
                        <Select
                            multiple
                            options={[
                                { value: 2, label: 'Brazil' },
                                { value: 3, label: 'Mexico' },
                                { value: 31, label: 'MCA North' },
                                { value: 32, label: 'MCA South' },
                            ]}
                            id="subregion"
                            label="Select Subregion"
                            value={subregion.value}
                            onClear={() => setsubregion({ value: [] })}
                            onChange={handleChange2}
                        />

                    </>
                );
                break;
        }
    }
    const handleSelectChange = (name) => (event) => {
        setaudience(event.value);
     };
    const handleClearChannel = (name) => (event) => {
        setaudience("");
    };
    const handleSubmit = () => {
        let data= new FormData();
        data.append("messageES",ESNoti);
        data.append("messageEN",ENNoti);
        data.append("messagePT",PTNoti);
        switch(audience){
            case "role":
                data.append("audiencelevel","role");
                var string="";
                roleselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "email":
                data.append("audiencelevel","email");
                var string="";
                emails.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "subregion":
                data.append("audiencelevel","subregion");
                var string="";
                subregion.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "enduser":
                data.append("audiencelevel","enduser");
                var string="";
                enduserselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audience",string);
                break;
            case "channel":
                var string="";
                channelselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                data.append("audiencelevel","channel");
                data.append("audience",string);
                break;
            case "role & subregion":
                var string="";
                roleselect.value.map((item, key) => {
                    if (string==""){
                        string=item;
                    }else{
                        string=string+","+item;
                    }
                    
                });
                string=string+",R";
                subregion.value.map((item, key) => {
                    
                    string=string+","+item;
                
                    
                });
                data.append("audiencelevel","role");
                data.append("audience",string);
                break;
        }
        data.append("startdate", moment(StartDate).format('DD/MMM/YYYY'));
        data.append("enddate", moment(EndDate).format('DD/MMM/YYYY'));
        //console.log(isnew);
        if (isnew=="NO"){
            data.append("idnotification", detailnotfication.idnotification);
        }
        connectApi.post("api/channels/savealert",data,alertssended)
    }
    function filter(array, filters) {
        let arrayFiltered = array;
    
        Object.keys(filters).forEach((value) => {
          const filterValue = filters[value];
          const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
          if (filter) {
            arrayFiltered = arrayFiltered.filter((a) => {
              const aUpper = a[value] && a[value].toString().toUpperCase();
              const filterUpper = filter && filter.toString().toUpperCase();
      
              return aUpper.indexOf(filterUpper) > -1;
            });
          }
        });
    
        return arrayFiltered;
    }
    const alertssended=(status,response)=>{
        if (status==200){
            window.location.href = window.location.href;
        }else{
            Swal.fire(
                'Error ' + response,
                response,
                'error'
              );
        }
    }
    const handleStartDate = (newDate) => {
        setStartDate(newDate);
    };
    const handleEndDate = (newDate) => {
        setEndDate(newDate);
    };
    const steps=()=>{
        if (NewStep=="1"){
            return (
                <TextArea
                    id="text-area-uncontrolled"
                    label={t("n_spanish")}
                    value={ESNoti}
                    onChange={(e) => {
                        setESNoti(e.replace(/\n/g,"\r\n"));
                    }
                    }
                />
            );
        }
        if (NewStep=="2"){
            return (<TextArea
                id="text-area-uncontrolled"
                label={t("n_english")}
                value={ENNoti}
                onChange={(e) => {
                    setENNoti(e.replace(/\n/g,"\r\n"));
                }
                }
            />);
        }
        if (NewStep=="3"){
            return (<TextArea
                id="text-area-uncontrolled"
                label={t("n_portuguese")}
                value={PTNoti}
                onChange={(e) => {
                    setPTNoti(e.replace(/\n/g,"\r\n"));
                }
                }
            />);
        }
        if (NewStep=="4"){
            return (
                <>
                <Row>
                    <Col xs="6" md="6">
                        <DatePicker
                            label="Start Date"
                            placeholder="mm/dd/yyyy"
                            onChange={handleStartDate}
                            value={StartDate}
                        />
                    </Col>
                    <Col xs="6" md="6">
                        <DatePicker
                            label="End Date"
                            placeholder="mm/dd/yyyy"
                            onChange={handleEndDate}
                            value={EndDate}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="6" md="6">
                        {t("select audience")}
                        <Select
                            options={[
                                { value: "email", label: 'Email' },
                                { value: "role", label: 'Role' },
                                { value: "subregion", label: 'Subregion' },
                                { value: "role & subregion", label: 'Role and Subregion' },
                                { value: "enduser", label: 'End User' },
                                { value: "channel", label: 'Channel' },
                            ]}
                            id="select-usage"
                            label={t("Audience")}
                            value={[audience]}
                            onClear={handleClearChannel()}
                            onChange={handleSelectChange()}
                        />
                    </Col>
                    <Col xs="6" md="6">
                        {select_audience()}
                    </Col>
                </Row>
                </>
            );
        }
        if (NewStep=="5"){
            return(
                <>
                <Row>
                    <Col xs="8" md="8"  >
                        <Tabs
                            controlId="default"
                            onChangeTab={(index) => {
                                setviewactivetab(index);
                            }}
                            selectedTabId={viewactivetab}
                            tabs={
                                [
                                { 
                                    id: 0, 
                                    label: 
                                    <>
                                        <img src={englishIcon} alt="Flag of United Kingdom" width="50%"></img>
                                    </>,
                                    content: 
                                
                                        <div style={{ height:"400px", "overflow-y": "scroll", }}>
                                            <h5 style={{ display: 'inline', verticalAlign: 'top', marginLeft: '10px' }}>We have some news for you</h5>
                                            <br/>
                                            {ENNoti.split('\r\n').map(en=>{return(<><p>{en}</p></>)})}
                                        </div>
                                    
                                },
                                { 
                                    id: 1, 
                                    label: 
                                    <>
                                        <img src={spanishIcon} alt="Flag of Spain" width="50%"></img>
                                    </>,
                                    content: 
                                    
                                        <div style={{ height:"400px", "overflow-y": "scroll", }}>
                                            <h5 style={{ display: 'inline', verticalAlign: 'top', marginLeft: '10px' }}>Tenemos algunas noticias para usted</h5>
                                            <br/>
                                            {ESNoti.split('\r\n').map(es=>{return(<><p>{es}</p></>)})}
                                        </div>
                                    
                                },
                                { 
                                    id: 2, 
                                    label: 
                                    <>
                                        <img src={portugueseIcon} alt="Flag of Portugal" width="50%"></img>
                                    </>, 
                                    content: 
                                
                                        <div style={{ height:"400px", "overflow-y": "scroll", }}>
                                            <h5 style={{ display: 'inline', verticalAlign: 'top', marginLeft: '10px' }}>Temos algumas notícias para você</h5>
                                            <br/>
                                            {PTNoti.split('\r\n').map(pt=>{return(<><p>{pt}</p></>)})}
                                        </div>
                                        
                                }  
                                ]
                            }
                            
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <div>
                            {t("specialcondition.startdate")}:{moment(StartDate).format('DD/MMM/YYYY')} 
                        </div>
                        <div>
                            {t("specialcondition.enddate")}:{moment(EndDate).format('DD/MMM/YYYY')} 
                        </div>
                        <hr/>
                        {(audience=="role")?(
                            <>
                                <div><b>Audience:</b> Role</div>
                                {optionsrole.map((item, key) => {
                                    if (roleselect.value.indexOf(item.value) > -1){
                                        return (
                                            <>
                                                <p><b>{item.label}</b></p>
                                            </>

                                        );
                                    }
                                })}
                            </>
                        ):(
                            (audience=="email")?(
                                <>
                                    <div><b>Audience:</b> Emails</div>
                                    <List css={{padding: '20px', height: '200px', overflowY: 'auto'}}>
                                    {
                                        emails.map((item, key) => {
                                            return(
                                                <>
                                                <ListItem 
                                                    centerArea={<div>{item}</div>}
                                                />
                                                </>
                                            )
                                        })
                                    }
                                </List>
                                </>
                                
                            ):(
                                (audience=="subregion")?(
                                    <>
                                        <div><b>Audience:</b> Subregions</div>
                                        {regionlist.map((item, key) => {
                                            if (subregion.value.indexOf(item.value) > -1){
                                                return (
                                                    <>
                                                        <p><b>{item.label}</b></p>
                                                    </>

                                                );
                                            }
                                        })}
                                    </>
                                    
                                ):((audience=="enduser")?(
                                    <>
                                        <div><b>Audience:</b> End Users</div>
                                        {enduserselect.value.map((item, key) => {
                                                return (
                                                    <>
                                                        <p><b>{item}</b></p>
                                                    </>

                                                )
                                            })}
                                    </>
                                    ):((audience=="channel")?(
                                        <>
                                            <div><b>Audience:</b> Channels</div>
                                            {optionsChannels.map((item, key) => {
                                                if (channelselect.value.indexOf(item.value) > -1){
                                                    return (
                                                        <>
                                                            <p><b>{item.label}</b></p>
                                                        </>

                                                    );
                                                }
                                            })}
                                        </>
                                        ):((audience=="role & subregion")?(
                                            <>
                                                <div><b>Audience:</b> Roles y Subregion</div>
                                                <p><b>Rols</b></p>
                                                {optionsrole.map((item, key) => {
                                                    if (roleselect.value.indexOf(item.value) > -1){
                                                        return (
                                                            <>
                                                                <p>{item.label}</p>
                                                            </>

                                                        );
                                                    }
                                                })}

                                                <p><b>Subregion</b></p>
                                                {regionlist.map((item, key) => {
                                                    if (subregion.value.indexOf(item.value) > -1){
                                                        return (
                                                            <>
                                                                <p>{item.label}</p>
                                                            </>

                                                        );
                                                    }
                                                })}
                                            </>
                                        ):(""))))
                            )
                        )}
                    </Col>
                </Row>  
                </>
            );
        }
    }
    return (<>
        <Modal
            id="regular-modal"
            show={onShowModal}
            onClose={() => { onCloseSCDetailsModal(); }}
            css={{
                '.vn-modal--content': {
                    width: "800px !important",
                    height:"750px !important",
                },
            }}
            title="Notification Alert"
        >
            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                <Stepper steps={stepItems} />
                <div style={formStyle}>
                    {steps()}
                    <div style={buttonsContainer}>
                        <Button
                            name="reset"
                            customStyle={resetButtonStyle}
                            small
                            onClick={handleResetButtonOnChange}
                        >
                            Reset
                        </Button>
                        {(NewStep!="1")?(
                            <Button
                                name="button"
                                appearance="secondary"
                                small
                                
                                customStyle={resetButtonStyle}
                                onClick={handleBackButtonOnChange}
                            >
                                Back
                            </Button>
                        ):("")}
                        {(NewStep!="5")?(
                            <Button
                                name="button"
                                customStyle={nextButtonStyle}
                                small
                                onClick={handleNextButtonOnChange}
                            >
                                Next
                            </Button>
                        ):(

                            <Button
                                name="button"
                                customStyle={nextButtonStyle}
                                small
                                onClick={handleSubmit}
                            >
                                Save
                            </Button>
                        )}
                        
                    </div>
                </div>
            </div>
        </Modal>
    </>);
}
export default DetNotification;